import * as React from 'react';
import { isNaN } from 'lodash-es';
import { ReactComponent as WarningIcon } from '../../svg/warning.svg';
import styles from './error.module.sass';

export type IErrorType =
  | 'PLAYER_NOT_FOUND'
  | 'VIDEO_SOURCE_ERROR'
  | 'INCORRECT_FILE_PASSWORD';

interface IErrorProps {
  videoConvertProgress?: number;
  errorType?: IErrorType;
}

const Error = ({ videoConvertProgress, errorType }: IErrorProps) => {
  const renderIcon = () => {
    if (errorType) return <WarningIcon />;

    return (
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="174"
          height="157"
          viewBox="0 0 174 157"
        >
          <g fill="none" fillRule="evenodd">
            <text
              fontSize="20"
              fill="#DFE6EE"
              textAnchor="middle"
              alignmentBaseline="baseline"
              x="78"
              y="75"
              fontWeight="bold"
            >
              {videoConvertProgress !== undefined &&
                !isNaN(videoConvertProgress) &&
                `${videoConvertProgress}%`}
            </text>
            <path
              stroke="#DFE6EE"
              strokeLinecap="square"
              strokeWidth="2"
              d="M1.183 139.648H172.22"
            />
            <path
              fill="#DFE6EE"
              fillRule="nonzero"
              d="M112.575 1.675L83 30.55 65 14c-.956-.956-1.969-1.881-2.925-.925-.956.956-.031 1.969.925 2.925l14.15 15.6H39.4C31.478 31.6 25 38.078 25 46v57.2c0 7.922 6.478 14.4 14.4 14.4h93.2c7.922 0 14.4-6.478 14.4-14.4V46c0-7.922-6.478-14.4-14.4-14.4H88.85L114 4c.778-.722 1.469-2.053 1-3-.46-.956-2.04.3-2.425.675zM39.4 36.4h47.15c.3.056.6.056.9 0h45.15a9.57 9.57 0 0 1 9.6 9.6v57.2a9.57 9.57 0 0 1-9.6 9.6H39.4a9.57 9.57 0 0 1-9.6-9.6V46a9.57 9.57 0 0 1 9.6-9.6zm37.8 3.4c-17.26 0-27.46-.234-34.125 4.65-3.328 2.437-5.353 6.15-6.45 11.025C35.528 60.35 35.2 66.528 35.2 74.6c0 8.081.328 14.25 1.425 19.125s3.122 8.588 6.45 11.025c6.666 4.884 16.866 4.65 34.125 4.65 17.175 0 27.431.272 34.125-4.575 3.347-2.419 5.344-6.131 6.45-11.025 1.106-4.894 1.425-11.053 1.425-19.2 0-8.138-.272-14.316-1.35-19.2-1.078-4.884-3.122-8.597-6.45-11.025-6.656-4.856-16.856-4.575-34.2-4.575zm0 4.8c17.344 0 26.953.337 31.425 3.6 2.24 1.631 3.572 4.031 4.5 8.25.928 4.219 1.275 10.134 1.275 18.15 0 8.016-.319 13.94-1.275 18.15-.956 4.21-2.39 6.61-4.65 8.25-4.519 3.272-14.1 3.6-31.275 3.6-17.24 0-26.84-.45-31.35-3.75-2.26-1.65-3.638-3.975-4.575-8.175C40.337 88.475 40 82.55 40 74.6c0-7.95.337-13.875 1.275-18.075.938-4.2 2.316-6.525 4.575-8.175 4.51-3.31 14.11-3.75 31.35-3.75zM129.5 71a3.498 3.498 0 0 0-3.5 3.5c0 1.935 1.565 3.5 3.5 3.5s3.5-1.565 3.5-3.5-1.565-3.5-3.5-3.5zm0 11a3.498 3.498 0 0 0-3.5 3.5c0 1.935 1.565 3.5 3.5 3.5s3.5-1.565 3.5-3.5-1.565-3.5-3.5-3.5zm.4 10.6c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5 5.5-2.46 5.5-5.5-2.46-5.5-5.5-5.5z"
            />
            <path
              fill="#DFE6EE"
              fillRule="nonzero"
              d="M73.003 134.143c.24-13.298 11.723-10.516 9.307-19.22-7.096-5.645-8.463-13.902-2.177-19.341-.12-5.68 5.199-8.582 5.199-8.582s3.868 3.869 3.505 7.615c3.386-1.088 8.705 2.418 9.55 3.627 1.815-3.022 8.22-2.9 8.22-2.9s2.055 8.098-3.143 11c-.725 7.01-6.016 10.506-9.429 10.759-.522 5.991 9.17 9.052 8.15 19.892 6.427 3.15 9.054 8.034 5.147 13.108-6.004 7.795-21.691 8.339-23.33 4.835-1.713-3.66 1.093-6.975 7.47-5.827 5.833 1.05 19.003-3.061 9.055-8.8-2.551 3.698-5.484 5.612-11.93 5.682-9.836.106-15.74-3.757-15.594-11.848z"
            />
            <path fill="#DFE6EE" d="M44 115h7l-5 24h-3zM128 115h-7l5 24h3z" />
          </g>
        </svg>
      </div>
    );
  };

  const getTitle = () => {
    if (errorType === 'PLAYER_NOT_FOUND') return 'Video not available';
    if (errorType === 'VIDEO_SOURCE_ERROR')
      return 'Wrong video URL or video not available';
    if (errorType) return 'Failed to load';

    return 'This video is being processed.';
  };

  const getSubtitle = () => (errorType ? null : 'Check back in a few minutes.');

  if (errorType === 'INCORRECT_FILE_PASSWORD') return null;

  return (
    <div className={styles.root}>
      <div className={styles.icon}>{renderIcon()}</div>
      <div className={styles.title}>{getTitle()}</div>
      <div className={styles.subtitle}>{getSubtitle()}</div>
    </div>
  );
};

export default Error;
